export default __webpack_public_path__ + "static/media/MarsCentra-Extrabold.850427ac.woff2";